import { EpostStatusTimelineContentContainer } from '../EpostStatusTimelineContentContainer'

import { TrackingItem } from './TrackingItem'

import * as styles from './EpostStatusTimelineTracking.module.css'

function EpostStatusTimelineTracking({ timeline }) {
  return (
    <EpostStatusTimelineContentContainer
      contentClassName={styles.statusList}
      titleKey='EpostStatusTimeline.TrackingStatusTitleKey'
    >
      {timeline.map(({ code, ...item }) => (
        <TrackingItem {...item} key={code} />
      ))}
    </EpostStatusTimelineContentContainer>
  )
}

export default EpostStatusTimelineTracking
